module.exports = __webpack_public_path__ + "static/media/resume-standout.8cebc7c9.svg";